module.exports = __webpack_public_path__ + "img/202306_02.19b58027.jpg";